/**
 * Converts Contentful's "CourseCard" content type to the appropriate component
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react'
import PropTypes from 'prop-types'
import CourseCard from 'components/CourseCard'

const ContentfulCourseCard = ({
  className,
  courseTitle,
  linkText,
  href,
  chooseTitle,
  chooseValue,
  timeTitle,
  timeValue,
  costTitle,
  costValue,
}) => {
  const courseCardProps = {
    className,
    title: courseTitle,
    linkText,
    href,
    choose: {
      title: chooseTitle,
      value: chooseValue,
    },
    time: {
      title: timeTitle,
      value: timeValue,
    },
    cost: {
      title: costTitle,
      value: costValue,
    },
  }

  return (
    <CourseCard {...courseCardProps} />
  )
}

ContentfulCourseCard.propTypes = {
  className: PropTypes.string,
  courseTitle: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  chooseTitle: PropTypes.string.isRequired,
  chooseValue: PropTypes.string.isRequired,
  timeTitle: PropTypes.string.isRequired,
  timeValue: PropTypes.string.isRequired,
  costTitle: PropTypes.string.isRequired,
  costValue: PropTypes.string.isRequired,
}

export default ContentfulCourseCard
